import { render, staticRenderFns } from "./Boardsettings.vue?vue&type=template&id=143b1e78&"
import script from "./Boardsettings.vue?vue&type=script&lang=js&"
export * from "./Boardsettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports